import {Injectable} from '@angular/core';
import {AbstractApiService} from '@wba/services/commons/abstract-api.service';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {LogDto} from '@wba/models/dto/log-dto';

@Injectable({
  providedIn: 'root'
})
export class LogService extends AbstractApiService {

  nachweisRequests: Map<string, {
    correlationId: string,
    nachweisId: string,
    startRequestTime: Date,
    milliSecondsBtwnRequestAndErrorResponse: number,
    request: any,
    response: any
  }> = new Map();

  constructor(protected http: HttpClient) {
    super(http);
  }

  log(logDto: LogDto): Observable<any> {
    return this.post<LogDto>(`/log`, logDto);
  }
}
